import ErrorContent from '@/pages/Errors/components/ErrorContent'
import {Component} from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null
    }
  }

  static getDerivedStateFromError(error) {
    return {hasError: true, error}
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  handleNavigation = () => {
    // this.props('/')
    window.location.href = '/'
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContent errorType="FAILED" errorDetails={this.state.error?.message} onClick={this.handleNavigation} />
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
